import {
  fadeInAnimation,
  flexCenter,
  PlyrVideoTabletStyles
} from '@anm/styles/helpers';
import styled from 'styled-components';

import { VideoLoadingPreviewProps } from '.';

const VideoLoadingPreviewWrapper = styled.div`
  ${flexCenter};
  opacity: ${({ isVisible }: Partial<VideoLoadingPreviewProps>) =>
    isVisible ? 1 : 0};
  > * {
    max-width: 100%;
    ${PlyrVideoTabletStyles};
    ${fadeInAnimation};
    height: 100%;
    animation-name: fadeIn;
    animation-duration: 1ms;
    animation-fill-mode: backwards;
    animation-delay: 1s;
    object-fit: contain;
  }
  pointer-events: none;
  z-index: 123;
  overflow: hidden;
  align-items: flex-start;
`;

export default VideoLoadingPreviewWrapper;
